import { render, staticRenderFns } from "./TotalPostsSharesAndComments.vue?vue&type=template&id=76665db9&scoped=true&"
import script from "./TotalPostsSharesAndComments.vue?vue&type=script&lang=js&"
export * from "./TotalPostsSharesAndComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76665db9",
  null
  
)

export default component.exports